import { normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92b22a0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["alt", "src", "srcset", "sizes"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PressModeDownloadButton = _resolveComponent("PressModeDownloadButton")!
  const _directive_on_error = _resolveDirective("on-error")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.maybeLazyInit), {
    class: _normalizeClass(["responsive-image", { 'responsive-image--loaded': _ctx.loadEventFired, 'flip-horizontal': _ctx.flip}]),
    style: _normalizeStyle(_ctx.style),
    offset: _ctx.offset
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("img", {
        ref: "image",
        alt: _ctx.alt,
        src: _ctx.src,
        srcset: _ctx.srcset,
        sizes: _ctx.sizesFromWidthOnScreen,
        class: _normalizeClass({'prevent-fade-anim': !_ctx.lazy, 'object-contain': _ctx.mode === 'contain'}),
        onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLoad && _ctx.handleLoad(...args)))
      }, null, 42, _hoisted_1), [
        [_directive_on_error]
      ]),
      (!_ctx.hidePressModeButton && _ctx.imageUrl)
        ? (_openBlock(), _createBlock(_component_PressModeDownloadButton, {
            key: 0,
            "image-url": _ctx.imageUrl,
            "is-product-image": _ctx.isProductImage,
            "cache-bust": _ctx.cacheBust.toString()
          }, null, 8, ["image-url", "is-product-image", "cache-bust"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class", "style", "offset"]))
}